export function curtain(visible: () => boolean) {
    const overlay = document.createElement("div");
    Object.assign(overlay.style, {
        position: "absolute",
        inset: "0",
        zIndex: "100",
        pointerEvents: "all",
        borderRadius: "inherit",
        backdropFilter: "blur(2px)",
    });
    let position: string | undefined;
    return (node: HTMLElement) => {
        $effect(() => {
            if (visible()) {
                const computedStyle = getComputedStyle(node);
                if (computedStyle.position === "static") {
                    position = node.style.position;
                    node.style.position = "relative";
                }
                node.appendChild(overlay);
            } else {
                if (position !== undefined) {
                    node.style.position = position;
                    position = undefined;
                }
                overlay.remove();
            }
        });
    };
}
